import { AppSportsBookState } from 'src/domains/sportsbook/state/AppSportsBook.state';
import { useCommon } from 'src/domains/common/Common';
import React from 'react';
import { observer } from 'src/utils/mobx-react';
import {
    DetailsWrapper,
    InfoContainer,
    StarValueWrapper,
    StarValueIcon,
    StarValueIconEmpty,
    SelectionName,
    StarRatingWrapper,
} from 'src/domains/sportsbook/webview/modules/AlternativeEvent/alternativeEventDetails/AlternativeEventDetails.style';
import { MaskImg } from 'src/domains/sportsbook/webview/modules/AlternativeEvent/maskImg/MaskImg';
import { MaskModelType } from 'src/domains/sportsbook/state/alternativeEventState/AlternativeCustomSelectionState';
import { EventId, SelectionId } from 'src_common/common/websocket2/id/WebsocketId';

const StarValue = ({ rating }: { rating: number }): JSX.Element => {
    const emptyStars = 5 - rating;
    const starsArray: Array<React.ReactNode> = [];

    for (let i = 0; i < rating; i++) {
        starsArray.push(<StarValueIcon key={`full-${i}`} />);
    }
    for (let j = 0; j < emptyStars; j++) {
        starsArray.push(<StarValueIconEmpty key={`empty-${j}`} />);
    }
    return <>{starsArray.map((star) => star)}</>;
};

interface StarRatingComponentPropsType {
    selectionId: SelectionId | null;
    mask: MaskModelType | null;
    name: string;
    starValue: number;
}

export const StarRatingComponent = observer('StarRatingComponent', (props: StarRatingComponentPropsType) => {
    const { mask, name, selectionId, starValue } = props;
    const selectionModel = selectionId?.getModel() ?? null;

    return (
        <DetailsWrapper>
            <InfoContainer>
                {selectionModel === null ? null : (
                    <MaskImg
                        mask={mask}
                        selectionId={selectionId}
                    />
                )}
                <SelectionName>{name}</SelectionName>
            </InfoContainer>

            <StarValueWrapper>
                <StarValue rating={starValue} />
            </StarValueWrapper>
        </DetailsWrapper>
    );
});

interface PropsType {
    eventId: EventId;
}

export const EventDetailsParticipants = observer('EventDetailsParticipants', (props: PropsType) => {
    const common = useCommon();
    const { alternativeEventState } = AppSportsBookState.get(common);

    const { getAlternativeEventItemById, eventId } = alternativeEventState.get(props.eventId);

    if (eventId === null) {
        return null;
    }

    const eventItem = getAlternativeEventItemById(eventId);

    const {
        customSelectionsForEventDetails,
        getCustomSelectionItemByMarketAndSelectionId,
        starRationParticipantsFromMarketFilter,
        activeMarketFilter,
        marketFilters,
    } = eventItem;

    return (
        <StarRatingWrapper>
            <div>
                {activeMarketFilter !== 'all' && marketFilters.length > 0
                    ? starRationParticipantsFromMarketFilter.map((elem) => {
                          return (
                              <StarRatingComponent
                                  key={elem.name}
                                  selectionId={null}
                                  mask={null}
                                  name={elem.name}
                                  starValue={elem.value}
                              />
                          );
                      })
                    : customSelectionsForEventDetails.map((selectionId) => {
                          const selectionItem = getCustomSelectionItemByMarketAndSelectionId(selectionId);
                          const { mask, starValue, name } = selectionItem;

                          return (
                              <StarRatingComponent
                                  key={selectionId.toOldId()}
                                  selectionId={selectionId}
                                  mask={mask}
                                  name={name}
                                  starValue={starValue}
                              />
                          );
                      })}
            </div>
        </StarRatingWrapper>
    );
});
